/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { fieldValueObjectSchema } from './fieldValueObjectSchema';

export const itemFieldValueSchema = z.object({
  fieldId: z.int(),
  fieldName: z.string(),
  fieldType: z.enum([
    'CHECKBOX',
    'CURRENCY',
    'DATE',
    'ITEM',
    'LINK',
    'MULTI_CUSTOMER',
    'MULTI_ITEM',
    'MULTI_LINK',
    'MULTI_PICKLIST',
    'MULTI_TEXT',
    'MULTI_USER',
    'MULTILINE_TEXT',
    'NOTE',
    'NUMERIC',
    'PICKLIST',
    'TEXT',
    'USER',
  ]),
  get fieldValue() {
    return z.array(fieldValueObjectSchema);
  },
  itemId: z.int(),
  supportsMultipleItems: z.boolean(),
});
